module.exports = __webpack_public_path__ + "img/speakap.84a2b193.svg";